import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'time',
    standalone: false
})
export class TimePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (!value) {
      return '';
    }
    return (!value) ? '' : moment(value).utc().format('HH:mm:ss');
  }

}
